import {call, put, takeEvery} from 'redux-saga/effects' 
import {
    FETCH_RESOURCE_LOADED,
    FETCH_RESOURCE_ERROR,
} from '../actions/auxiliar_actions'
import { isValidateToken } from '../utils/utils';

import {
    FETCH_GET_MODELS,
    FETCH_GET_MODELS_SUCCESS,
    FETCH_GET_DATA_MODEL,
    FETCH_GET_DATA_MODEL_SUCCESS,
    FETCH_GET_STATS_MODEL,
    FETCH_GET_STATS_MODEL_SUCCESS,
    FETCH_GET_TREND_MODEL,
    FETCH_GET_TREND_MODEL_SUCCESS,
    FETCH_GET_PING_MODEL,
    FETCH_GET_PING_MODEL_SUCCESS,
} from '../actions/model_actions';
import {
    FETCH_RENEW_PASSWORD_SUCCESS,
    // FETCH_GET_MODELS_SUCCESS,
} from '../actions/auth_actions';
import { getModels, getModelData, getStatsModel, getTrendModel, getPingModel } from '../services/model_services';
import { refreshToken } from '../services/auth_services';

function* fetchGetModelsSaga({payload}){
    try {
        let token = payload && payload.params && payload.params.token ? payload.params.token : "";
        const modelsResponse = yield call(getModels, token);
        console.log(modelsResponse)
        let data = modelsResponse ? modelsResponse.data : null
        if(modelsResponse && modelsResponse.status === 200){
            yield put({type: FETCH_GET_MODELS_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                console.log("Refresh: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    // let token = payload && payload.params && payload.params.token ? payload.params.token : "";
                    const modelsResponse2 = yield call(getModels, refreshResponse.data.idToken);
                    console.log(modelsResponse2)
                    let data = modelsResponse2 ? modelsResponse2.data : null
                    if(modelsResponse2 && modelsResponse2.status === 200){
                        yield put({type: FETCH_GET_MODELS_SUCCESS, payload: data})
                        yield put({type: FETCH_RESOURCE_LOADED})
                    }
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        console.log(error)
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetDataModelSaga({payload}){
    try {
        // console.log(payload)
        let token = payload && payload.params && payload.params.token ? payload.params.token : "";
        let idModel = payload && payload.params && payload.params.idModel ? payload.params.idModel : "";

        const modelResponse = yield call(getModelData, token, idModel);
        // console.log(modelResponse)
        let data = modelResponse.data
        if(modelResponse && modelResponse.status === 200){
            yield put({type: FETCH_GET_DATA_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh Model: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetStatsModelSaga({payload}){
    try {
        // console.log(payload)
        let token = payload && payload.params && payload.params.token ? payload.params.token : "";
        let idModel = payload && payload.params && payload.params.idModel ? payload.params.idModel : "";

        const statsModelResponse = yield call(getStatsModel, token, idModel);
        // console.log(statsModelResponse)
        let data = statsModelResponse.data
        if(statsModelResponse && statsModelResponse.status === 200){
            yield put({type: FETCH_GET_STATS_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh Stats: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetTrendModelSaga({payload}){
    try {
        // console.log(payload)
        let token = payload && payload.params && payload.params.token ? payload.params.token : "";
        let idModel = payload && payload.params && payload.params.idModel ? payload.params.idModel : "";

        const trendModelResponse = yield call(getTrendModel, token, idModel);
        // console.log(trendModelResponse)
        let data = trendModelResponse.data
        if(trendModelResponse && trendModelResponse.status === 200){
            yield put({type: FETCH_GET_TREND_MODEL_SUCCESS, payload: data})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh Trend: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else yield put({type: FETCH_RESOURCE_ERROR, payload: data});
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* fetchGetPingModelSaga({payload}){
    try {
        // console.log(payload)
        let token = payload && payload.params && payload.params.token ? payload.params.token : "";
        let user_id = payload && payload.params && payload.params.user_id ? payload.params.user_id : "";
        let idModel = payload && payload.params && payload.params.idModel ? payload.params.idModel : "";

        const pingModelResponse = yield call(getPingModel, token, user_id, idModel);
        console.log("Ping: ",pingModelResponse)
        let data = pingModelResponse.data
        if(pingModelResponse && pingModelResponse.status === 200){
            yield put({type: FETCH_GET_PING_MODEL_SUCCESS, payload: {
                response: data,
                status: pingModelResponse.status
            }})
            yield put({type: FETCH_RESOURCE_LOADED})
        } else {
            let renewToken = document.cookie.replace(/(?:(?:^|.*;\s*)refreshToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");

            if(data && data.detail && isValidateToken(data.detail)) {
                const refreshResponse = yield call(refreshToken, renewToken);
                // console.log("Refresh Trend: ", refreshResponse)
                if(refreshResponse.status === 200){
                    document.cookie = `idToken=${refreshResponse.data.idToken}; max-age=${60*60*3}; path=/`
                    document.cookie = `refreshToken=${refreshResponse.data.refreshToken}; max-age=${60*60*3}; path=/`
                    refreshResponse.data.action = "New Token"
                    yield put({type: FETCH_RENEW_PASSWORD_SUCCESS, payload: refreshResponse.data})
                    yield put({type: FETCH_RESOURCE_LOADED})
                } else {
                    yield put({type: FETCH_RESOURCE_ERROR, payload: refreshResponse.data})
                }
            } else {
                yield put({type: FETCH_RESOURCE_ERROR, payload: data});
                yield put({type: FETCH_GET_PING_MODEL_SUCCESS, payload: {
                    response: data,
                    status: pingModelResponse.status
                }})
            }
        }
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* watchGetModelsSagas(){
    yield takeEvery(FETCH_GET_MODELS, fetchGetModelsSaga)
}

function* watchGetDataModelSagas(){
    yield takeEvery(FETCH_GET_DATA_MODEL, fetchGetDataModelSaga)
}

function* watchGetStatsModelSagas(){
    yield takeEvery(FETCH_GET_STATS_MODEL, fetchGetStatsModelSaga)
}

function* watchGetTrendModelSagas(){
    yield takeEvery(FETCH_GET_TREND_MODEL, fetchGetTrendModelSaga)
}

function* watchGetPingModelSagas(){
    yield takeEvery(FETCH_GET_PING_MODEL, fetchGetPingModelSaga)
}

export default [
    watchGetModelsSagas, 
    watchGetDataModelSagas, 
    watchGetStatsModelSagas, 
    watchGetTrendModelSagas, 
    watchGetPingModelSagas
]

// eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE1ODAxMDEwNTYsImZyZXNoIjpmYWxzZSwiaWRlbnRpdHkiOiJhZG1pbkBhZG1pbi5jb20iLCJpYXQiOjE1ODAxMDEwNTYsInR5cGUiOiJhY2Nlc3MiLCJqdGkiOiIwMzI4MzdkZC1kYTdiLTRjZGMtODdjOS00ZWQ1OTM1NjkzYjIiLCJleHAiOjE1ODI2OTMwNTZ9.veBoRI1VQs4gAGT73Txbl0HKMsRwMA9eSK5q9m_Sak8